import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadCoverageReportListEpic } from './_epics/loadCoverageReportList.epic';
import { createCoverageReportEpic } from './_epics/createCoverageReport.epic';
import { updateCoverageReportEpic } from './_epics/updateCoverageReport.epic';
import { removeCoverageReportEpic } from './_epics/removeCoverageReport.epic';

export const coverageReportEpic = safeCombineEpics(
  loadCoverageReportListEpic,
  createCoverageReportEpic,
  updateCoverageReportEpic,
  removeCoverageReportEpic,
);
